export default __webpack_public_path__ + "static/media/information-system.5ca31033.svg";